import { render, staticRenderFns } from "./Airticketyudingshenqing.vue?vue&type=template&id=1eb15d82&scoped=true"
import script from "./Airticketyudingshenqing.vue?vue&type=script&lang=js"
export * from "./Airticketyudingshenqing.vue?vue&type=script&lang=js"
import style0 from "./Airticketyudingshenqing.vue?vue&type=style&index=0&id=1eb15d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb15d82",
  null
  
)

export default component.exports